/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { injectIntl, FormattedMessage, useIntl } from 'react-intl';
import {
  Container,
  Typography,
  Grid,
  Button,
  QuoteButton,
} from '../../canvasComponents/index';
// scss
import '../../css/domain/Dashboard/Dashboard.scss';
import ConsentPopUp from '../../components/ConsentPopUp/ConsentPopUp';
import RemoveClaimPopUp from '../../components/RemoveClaimPopUp/RemoveClaimPopUp';
import ClaimTile from '../../components/ClaimTile/ClaimTile';
import ErrorPopupGeneric from '../../components/ErrorPopup/ErrorPopupGeneric';
// icons
import claimLogo from './img/makeClaimThin.svg';
import rightArrow from '../../img/global/chevron.svg';
import submittedIcon from '../../img/status/SubmittedStatus.svg';
import towLogo from './img/towTruck.svg';
import callLogo from './img/telephone.svg';
import homeRepair from '../../img/global/iconHomeRepair.svg';
// messages
import messages from './messages';
// selectors
import {
  claimsDataSelector,
  selectCreatedClaimSelector,
  gwClaimsDataSelector,
  selectCreatedShellClaimSelector,
} from '../../redux/Claims/selector';
import { authenticationDataSelector } from '../../redux/Authentication/selector';
// redux
import { createClaim, updateClaim } from '../../redux/Claims/actions';
// hooks
import { useFirstRender } from '../../hooks/useFirstRender';
import { getClaimLossCause } from '../../utils/constants/typeClaimMapping';
// Components
import AdjusterDetailsPopUp from '../../components/AdjusterDetailsPopUp/AdjusterDetailsPopUp';
import IdealUserPopUp from '../../components/IdealUserPopUp/IdealUserPopUp';
import FAQs from '../../components/FAQs/FAQs';
// containers
import RetrieveClaims from '../../containers/RetrieveClaims';
// Utils
import * as types from '../../utils/constants/claimStatusTypes';
import { getFormattedDateClaimsBff, getFormattedDateClaimsGW } from '../../utils/common/dates/getFormattedDate';
import { getRemainingDaysToCompleteClaim } from '../../utils/common/dates/getRemainingDaysToCompleteClaim';
import { getClaimStatus, getGWClaimStatus } from '../../utils/claim/getClaimStatus';
import convertSubmissionObjectToGW from '../../utils/common/convertSubmissionObjectToGW';

function dashboard(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstRender = useFirstRender();
  const intl = useIntl();
  const { authentication, gwClaims, claims } = props;
  const { sonnetAddressBookUid, preferredLang } = authentication;
  const [claimsData, setClaimsData] = useState([]);
  const [gwClaimsData, setGwClaimsData] = useState([]);
  const [claimId, setClaimId] = useState(null);
  const [claimTitle, setClaimTitle] = useState('');
  const [openConsentPopUp, setOpenConsentPopUp] = useState(false);
  const [openRemoveClaimPopUp, setOpenRemoveClaimPopUp] = useState(false);
  const [claimToRemove, setClaimToRemove] = useState(null);
  const [openAdjusterDetailsPopUp, setOpenAdjusterDetailsPopUp] = useState(false);
  const [adjusterDetails, setAdjusterDetails] = useState({ name: null, phone: null, email: null, oracleId: null });
  const [isClaimsAvailable, setIsClaimsAvailable] = useState(null);
  const [isClaimsLoaded, setIsClaimsLoaded] = useState(null);
  const [showErrorForClientSonnet, setShowErrorForClientSonnet] = useState(false);

  useEffect(() => {
    /**
     * Filtering out claims based on cdsClaimNumber recieving from GW Claims and BFF Claims
     * Dashboard must show claims from BFF, until same claim (with same cdsClaimNumber) is being recieved from GW data source
     */
    const filteredClaims = [];
    claims.data.forEach((claim) => {
      const foundDuplicate = Boolean(gwClaims.data.find((gwClaim) =>
      (claim.cdsClaimNumber !== null && gwClaim.cdsClaimNumber === claim.cdsClaimNumber) || 
      (claim.gwClaimNumber !== null && gwClaim.gwClaimNumber === claim.gwClaimNumber))
      );
      if(!foundDuplicate) {
        filteredClaims.push(claim);
      }
    });
    setClaimsData(filteredClaims);
    setGwClaimsData(gwClaims.data);

    setIsClaimsLoaded(gwClaims?.loading === false && claims?.loading === false ? true : false);
    setIsClaimsAvailable(gwClaims?.data?.length !== 0 || filteredClaims.length !== 0 ? true : false);
  }, [claims, gwClaims]);

  /**
   * Set Claim ID after Creating a New Claim
   */
  useEffect(() => {
    if (!isFirstRender) {
      setClaimId(props.createdClaim.data);
    }
  }, [props.createdClaim.data]);

  useEffect(() => {
    if (claimId) {
      window.sessionStorage.setItem('claimId', claimId);
      navigate('/claims/', {
        state: { claimTitle },
      });
    }
  }, [claimId, claimTitle, navigate]);

  useEffect(() => {
    // remove claim specific data from sessionStorage after landing on dashboard.
    const sessionStorageKeys = ['policyDetails', 'thePolicy', 'claimNumber', 'idMapping', 'policyAddress', 'updateClaimPayload', 'scheduledItems', 'digitalFNOLStatus', 'propertyType', 'claimId', 'isClaimAutoSaved', 'resumeReview'];
    sessionStorageKeys.forEach((key) => {
      sessionStorage.removeItem(key);
    });
  }, []);

  const createClaimHandler = (title) => {
    setClaimTitle(title);
    dispatch(createClaim(preferredLang));
  };

  const onRemovePopUpClickHandler = (claim) => {
    setClaimToRemove(claim);
    setOpenRemoveClaimPopUp(true);
  };

  const onConfirmRemovePopUpHandler = () => {
    const stringifiedSubmittedData = JSON.stringify(claimToRemove.submittedData);
    let stringifiedMetadata;
    if (claimToRemove.metadata) {
      stringifiedMetadata = JSON.stringify(claimToRemove.metadata).replace(/"/g, '\\"');
    } else {
      stringifiedMetadata = '';
    }
    let stringifiedSubmittedDataGW = claimToRemove.submittedData;
    stringifiedSubmittedDataGW.digitalFNOLStatus = types.CLAIM_STATUS_CANCELLED;
    stringifiedSubmittedDataGW = convertSubmissionObjectToGW(claimToRemove.submittedData);
    stringifiedSubmittedDataGW = JSON.stringify(stringifiedSubmittedDataGW);
    const leaveForm = true;
    dispatch(updateClaim(claimToRemove.claimId, types.CLAIM_STATUS_CANCELLED, stringifiedSubmittedData, stringifiedSubmittedDataGW, true, preferredLang, stringifiedMetadata, true, leaveForm));
  };

  const remainingDaysUntilExpires = (claim) => {
    if (claim.digitalFNOLStatus === types.CLAIM_STATUS_IN_PROGRESS) {
      if (getRemainingDaysToCompleteClaim(claim, true) < 1) {
        return (
          <span className="redText">
            <FormattedMessage {...messages.expiresToday} />
          </span>
        );
      }

      return (
        <span className="redText">
          <FormattedMessage
            {...messages.expiresDate}
            values={{
              untilDaysUntilExpires: getRemainingDaysToCompleteClaim(
                claim,
                true,
              ).toString(),
            }}
          />
        </span>
      );
    }
  };

  const claimLinkText = (claim) => (
    <div>
      <span className="claimNumberText">
        {claim?.cdsClaimNumber && claim.cdsClaimNumber !== 'cdsClaimNumber' ? (
          <FormattedMessage
            {...messages.claimNumberText}
            values={{
              claimId: claim.cdsClaimNumber,
            }}
          />
        ) : (
          <FormattedMessage
            {...messages.claimNumberGW}
            values={{ claimId: claim.gwClaimNumber }}
          />
        )}
      </span>
      <span className="claimNumberNoText">
        {claim?.cdsClaimNumber && claim.cdsClaimNumber !== 'cdsClaimNumber' ? (
          <FormattedMessage {...messages.claimNumberNoText} values={{ claimId: claim.cdsClaimNumber }} />
        ) : (
          <FormattedMessage {...messages.claimNumberNoText} values={{ claimId: claim.gwClaimNumber }} />
        )}
      </span>
    </div>
  );

  return (
    <Container fluid className="dashboard-content">
      <RetrieveClaims />
      {showErrorForClientSonnet &&
        <ErrorPopupGeneric
          open
          closeErrorPopUp={() => { window.location.reload() }}
        />
      }
      <ConsentPopUp
        open={openConsentPopUp}
        sonnetAddressBookUid={sonnetAddressBookUid}
        closeConsentPopUp={() => setOpenConsentPopUp(false)}
        agreeConsentPopUp={() => createClaimHandler(messages.reportAClaim.defaultMessage)}
      />
      <RemoveClaimPopUp
        open={openRemoveClaimPopUp}
        closeRemovePopUp={() => setOpenRemoveClaimPopUp(false)}
        confirmRemovePopUp={() => onConfirmRemovePopUpHandler()}
      />
      <AdjusterDetailsPopUp
        open={openAdjusterDetailsPopUp}
        closeAdjusterDetailsPopUp={() => {
          setOpenAdjusterDetailsPopUp(false);
          setAdjusterDetails({ name: null, phone: null, email: null, oracleId: null });
        }}
        data={adjusterDetails}
      />
      <IdealUserPopUp />
      <Grid>
        <Grid.Row>
          <Grid>
            <Grid.Row>
              <Grid.Column colSm12>
                <div className="dashboard-title claim-dashboard-title">
                  <FormattedMessage {...messages.title} />
                </div>
                <p className="dashboard-sub-title">
                  <FormattedMessage {...messages.connectUs} />
                </p>
              </Grid.Column>
            </Grid.Row>
            <div className="main-buttons-container">
              <Grid.Row justifyContentCenter flex>
                <div className="main-button first-line-button">
                  <Grid.Column colSmAuto justifyContentCenter flex mbMd>
                    <QuoteButton
                      className="quote_button"
                      onClick={() => setOpenConsentPopUp(true)}
                    >
                      <span className="btn-logo-container">
                        <img
                          className="btn-logo claim-logo"
                          src={claimLogo}
                          alt="Claim Logo"
                        />
                      </span>
                      <span className="btn-txt-container">
                        <span className="button-title">
                          <FormattedMessage {...messages.reportAClaim} />
                        </span>
                        <p className="button-subtitle">
                          <FormattedMessage {...messages.reportAClaimSubtitle} />
                        </p>
                      </span>
                    </QuoteButton>
                  </Grid.Column>
                </div>
              </Grid.Row>
              <Grid.Row justifyContentCenter flex>
                <div className="main-button second-line-buttons">
                  <Grid.Column colSmAuto justifyContentCenter flex mbMd>
                    <QuoteButton
                      // it's redirecting, but the user is not logged in on the sonnet.ca
                      onClick={() => { window.open(intl.formatMessage({ ...messages.getATowUrl }), '_blank'); }}
                    >
                      <span className="btn-logo-container">
                        <img
                          className="btn-logo tow-logo"
                          src={towLogo}
                          alt="Tow Logo"
                        />
                      </span>
                      <span className="btn-txt-container">
                        <span className="button-title">
                          <FormattedMessage {...messages.getATow} />
                        </span>
                        <p className="button-subtitle">
                          <FormattedMessage {...messages.getATowSubtitle} />
                        </p>
                      </span>
                    </QuoteButton>
                  </Grid.Column>
                  <Grid.Column colSmAuto justifyContentCenter flex>
                    <QuoteButton
                      onClick={() => { window.open(intl.formatMessage({ ...messages.emergencyHomeRepairsUrl }), '_blank'); }}
                    >
                      <span className="btn-logo-container">
                        <img
                          className="btn-logo tow-logo"
                          src={homeRepair}
                          alt="Home Repair Logo"
                        />
                      </span>
                      <span className="btn-txt-container">
                        <span className="button-title">
                          <FormattedMessage {...messages.emergencyHomeRepais} />
                        </span>
                        <p className="button-subtitle">
                          <FormattedMessage {...messages.emergencyHomeRepaisSubtitle} />
                        </p>
                      </span>
                    </QuoteButton>
                  </Grid.Column>
                </div>
              </Grid.Row>
            </div>
            <Grid.Row>
              <Grid.Column colSm12>
                <div className="dashboard-call">
                  <span className="call-logo-container">
                    <img className="call-logo" src={callLogo} alt="Call Logo" />
                  </span>
                  <span className="call-text-container">
                    <Button className="blueUnderlineButton">
                      <a className="blueUnderlineButton" href="tel:1-844-766-6384">
                        <FormattedMessage {...messages.callUs} />  1-844-766-6384
                      </a>
                    </Button>
                  </span>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Row>
        <Grid.Row justifyContentCenter flex>
          <div className="claimsGrid">
            <Typography h2 center>
              <div className="dashboard-title title-margin-bottom ">
                <FormattedMessage {...messages.claimsDraft} />
              </div>
            </Typography>

            {isClaimsLoaded && !isClaimsAvailable && <ClaimTile noFoundClaims />}

            {claimsData?.map(
              (claim) => getClaimStatus(claim.digitalFNOLStatus, claim.assisted, 'en') !== types.CLAIM_STATUS_CANCELLED && (
                <div key={claim.claimId} className="claim-divider">
                  <Grid>
                    <Grid.Row>
                      <div className="claim-row">
                        <Grid.Column colSm6>
                          <span className="claim-title">
                            <h2 className="h2title">
                              {claim.assisted || claim.digitalFNOLStatus === types.CLAIM_STATUS_SUBMITTED ? (
                                <div className="claim-number">
                                  {claimLinkText(claim)}
                                </div>
                              ) : (
                                <div
                                  role="button"
                                  tabIndex="-1"
                                  onClick={() => {
                                    window.sessionStorage.setItem('claimId', claim.claimId);
                                    navigate('/claims/', {
                                      state: { claimTitle },
                                    });
                                  }}
                                  className="claim-number"
                                >
                                  {claimLinkText(claim)}
                                </div>
                              )}
                            </h2>
                          </span>
                        </Grid.Column>
                        <Grid.Column colSm6>
                          <div className="textOnTheRight">
                            {/* STATUS */}
                            {claim.digitalFNOLStatus === types.CLAIM_STATUS_IN_PROGRESS && !claim.assisted ? (
                              <Button
                                className="buttonNoPadding"
                                onClick={() => {
                                  window.sessionStorage.setItem('claimId', claim.claimId);
                                  if (claim?.submittedDataGW?.scheduledItems?.length) {
                                    window.sessionStorage.setItem('scheduledItems', JSON.stringify(claim.submittedDataGW.scheduledItems));
                                  }
                                  navigate('/claims/', {
                                    state: { claimTitle },
                                  });
                                }}
                              >
                                <span className="desktop-label underline-animation">
                                  <FormattedMessage {...messages.continueClaim} />
                                  <img
                                    src={rightArrow}
                                    alt=""
                                    className="chevron-icon"
                                  />
                                </span>
                                <span className="phone-label underline-animation">
                                  <FormattedMessage {...messages.continueClaimPhone} />
                                  <img
                                    src={rightArrow}
                                    alt=""
                                    className="chevron-icon"
                                  />
                                </span>
                              </Button>
                            ) : (
                              <span className="submittedStatus">
                                <img alt="" src={submittedIcon} className="status-icon status-icon--left" />
                                <FormattedMessage
                                  {...messages.claimStatus}
                                  values={{ claimStatus: getClaimStatus(claim.digitalFNOLStatus, claim.assisted, preferredLang?.substring(0, 2)) }}
                                />
                              </span>
                            )}
                          </div>
                        </Grid.Column>
                      </div>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column colSm4>
                        <span className="claim-detail-subtitle extra-right-margin">
                          {claim.submittedData?.claim_type?.claim_type === 'Vehicle' && <FormattedMessage {...messages.vehicle} />}
                          {claim.submittedData?.claim_type?.claim_type === 'Home' && <FormattedMessage {...messages.property} />}
                        </span>
                      </Grid.Column>
                      <Grid.Column colSm4>
                        <span className="claim-detail-subtitle extra-right-margin">
                          <FormattedMessage {...messages.claimType} />
                        </span>
                      </Grid.Column>
                      <Grid.Column colSm4>
                        <span className="claim-detail-subtitle">
                          <FormattedMessage {...messages.incidentDate} />
                        </span>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column colSm4>
                        <span className="claim-detail-answer extra-right-margin">
                          {/* VEHICLE */}
                          {claim.submittedData?.claim_type?.claim_type === 'Vehicle' && claim.submittedData.claim_type.vehicle
                            && Object.keys(claim.submittedData.claim_type.vehicle).length > 0 && claim.submittedData?.claim_type.vehicle?.make ? (
                            <FormattedMessage
                              {...messages.vehicleModel}
                              values={{
                                vehicleModel: `${claim.submittedData?.claim_type?.vehicle.year} ${claim.submittedData?.claim_type?.vehicle.make} ${claim.submittedData?.claim_type?.vehicle.model}`,
                              }}
                            />
                          ) : (
                            <FormattedMessage
                              {...messages.vehicleModel}
                              values={{ vehicleModel: '' }}
                            />
                          )}
                          {/* HOME ADDRESS */}
                          {claim.submittedData?.claim_type?.claim_type === 'Home' && claim.submittedData.claim_type.property?.address?.addressLine1 ? (
                            <FormattedMessage
                              {...messages.propertyAddress}
                              values={{
                                propertyAddress: claim.submittedData.claim_type.property.policySystemId === 'somewhereElse' ? intl.formatMessage({ id: claim.submittedData.claim_type.property.address.addressLine1, defaultMessage: claim.submittedData.claim_type.property.address.addressLine1 }) : claim.submittedData.claim_type.property.address.addressLine1,
                              }}
                            />
                          ) : (
                            <FormattedMessage
                              {...messages.propertyAddress}
                              values={{ propertyAddress: '' }}
                            />
                          )}
                        </span>
                      </Grid.Column>
                      <Grid.Column colSm4>
                        <span className="claim-detail-answer extra-right-margin">
                          {/* CLAIM TYPE - HOME */}
                          {claim.submittedData?.claim_type?.claim_type === 'Home'
                            && <FormattedMessage id={getClaimLossCause[claim.submittedData?.property?.data?.lossCause?.value ? claim.submittedData.property.data.lossCause.value : 'default']} defaultMessage={getClaimLossCause[claim.submittedData?.property?.data?.lossCause?.value ? claim.submittedData.property.data.lossCause.value : 'default']} />}
                          {/* CLAIM TYPE - AB ONLY */}
                          {claim.submittedData?.claim_type?.claim_type === 'Vehicle' && claim.submittedData.claim_type.vehicle?.policySystemId === 'injuryOnly'
                            && <FormattedMessage id={getClaimLossCause[claim.submittedData?.abonly?.data?.lossCause?.value ? claim.submittedData.abonly.data.lossCause.value : 'default']} defaultMessage={getClaimLossCause[claim.submittedData?.abonly?.data?.lossCause?.value ? claim.submittedData.abonly.data.lossCause.value : 'default']} />}
                          {/* CLAIM TYPE - AUTO */}
                          {claim.submittedData?.claim_type?.claim_type === 'Vehicle' && claim.submittedData.claim_type.vehicle?.policySystemId !== 'injuryOnly'
                            && <FormattedMessage id={getClaimLossCause[claim.submittedData?.auto?.data?.lossCause?.value ? claim.submittedData.auto.data.lossCause.value : 'default']} defaultMessage={getClaimLossCause[claim.submittedData?.auto?.data?.lossCause?.value ? claim.submittedData.auto.data.lossCause.value : 'default']} />}
                        </span>
                      </Grid.Column>
                      <Grid.Column colSm4>
                        <span className="claim-detail-answer">
                          {/* INCIDENT DATE */}
                          <FormattedMessage
                            {...messages.dateOfIncident}
                            values={{
                              formattedDate: getFormattedDateClaimsBff(claim.submittedData?.lossDate?.value),
                            }}
                          />
                        </span>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <div className="claim-row">
                        <Grid.Column colSm8>
                          <span>
                            {/* Remaining Days Until Expires */}
                            {!claim.assisted && (remainingDaysUntilExpires(claim))}
                          </span>
                        </Grid.Column>
                        <Grid.Column colSm4>
                          <div className="textOnTheRight">
                            {/* REMOVE CLAIM BUTTON */}
                            {claim.digitalFNOLStatus === types.CLAIM_STATUS_IN_PROGRESS && !claim.assisted && (
                              <Button
                                className="blueUnderlineButton textOnTheRight"
                                onClick={() => onRemovePopUpClickHandler(claim)}
                              >
                                <FormattedMessage
                                  {...messages.removeClaim}
                                />
                              </Button>
                            )}
                          </div>
                        </Grid.Column>
                      </div>
                    </Grid.Row>
                  </Grid>
                </div>
              ),
            )}

            {gwClaimsData?.map((gwClaim) => (
              <ClaimTile
                key={gwClaim.gwClaimId}
                isActive={false}
                formattedDate={getFormattedDateClaimsGW(gwClaim.lossDate)}
                handleOnClickAdjuster={() => {
                  setAdjusterDetails({
                    name: gwClaim.adjusterDetails?.name,
                    phone: gwClaim.adjusterDetails?.phoneNumber,
                    email: gwClaim.adjusterDetails?.emailAddress,
                    oracleId: gwClaim.adjusterDetails?.oracleId,
                  });
                  setOpenAdjusterDetailsPopUp(true);
                }}
                claimLossScenarioLevel1={gwClaim.lossScenarioLevel1}
                vehicleModel={gwClaim.insuredVehicle?.displayName_Ext}
                propertyAddress={gwClaim.lossLocation?.displayName_Ext}
                gwClaimStatus={getGWClaimStatus(gwClaim.gwClaimStatus, preferredLang?.substring(0, 2))}
                gwClaimId={gwClaim.gwClaimId}
                gwCdsClaimNumber={gwClaim.cdsClaimNumber}
                gwClaimNumber={gwClaim.gwClaimNumber}
                adjusterDetails={gwClaim.adjusterDetails}
                language={preferredLang?.substring(0, 2)}
              />
            ))}
          </div>
        </Grid.Row>
        {/* FAQs */}
        <Grid.Row>
          <div className="dashboard-title title-margin-bottom title-margin-top">
            <FormattedMessage {...messages.faqs} />
          </div>
          <FAQs />
        </Grid.Row>
      </Grid>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  claims: claimsDataSelector(state.claims),
  gwClaims: gwClaimsDataSelector(state.claims),
  createdClaim: selectCreatedClaimSelector(state.claims),
  createdShellClaim: selectCreatedShellClaimSelector(state.claims),
  authentication: authenticationDataSelector(state.authentication),
});

export default injectIntl(connect(mapStateToProps)(dashboard));
